import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram';
import { MdEmail, MdLocationOn } from "react-icons/md";
import { Bio } from '../../data/constants';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import ReactGA from 'react-ga4';

const SocialMediaIcons = styled.div`
  display: flex;
  align-items: center;
`;

const SocialMediaIcon = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const trackSocialClick = (platform) => {
  ReactGA.event({ category: 'Social', action: 'outbound_click', label: platform });
};

const SocialLinks = ({ onLocationClick }) => {
  return (
    <SocialMediaIcons>
          <SocialMediaIcon href={Bio.github} target="_blank" rel="noopener noreferrer" onClick={() => trackSocialClick('github')}><FaGithub title="GitHub" /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.linkedin} target="_blank" rel="noopener noreferrer" onClick={() => trackSocialClick('linkedin')}><FaLinkedin title="LinkedIn" /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.insta} target="_blank" rel="noopener noreferrer" onClick={() => trackSocialClick('instagram')}><InstagramIcon title="Instagram"/></SocialMediaIcon>
          <SocialMediaIcon href={Bio.email} target="_blank" rel="noopener noreferrer" onClick={() => trackSocialClick('email')}><MdEmail title="Email" /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.whatsapp} target="_blank" rel="noopener noreferrer" onClick={() => trackSocialClick('whatsapp')}><FaWhatsapp title="WhatsApp (+1-602-657-1344)" /></SocialMediaIcon>
          <SocialMediaIcon as="button" onClick={() => { trackSocialClick('location'); onLocationClick(); }} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
            <MdLocationOn title="Location" />
          </SocialMediaIcon>
    </SocialMediaIcons>
  )
}

export default SocialLinks